// When the app is served over HTTPS, browsers block plain ws:// connections
// (mixed content), and the robots' rosbridge can't be reached directly with a
// publicly-trusted cert anyway. So we route through the droplet: nginx on
// mobile.salin247.com terminates TLS and reverse-proxies the WebSocket
// upgrade to the robot's rosbridge over the Tailscale network.
//
// In HTTP mode (local dev), we connect directly to the robot's rosbridge on
// :9090 — same as before.
const PROXY_HOST = "mobile.salin247.com";
const ROSBRIDGE_PORT = 9090;

export const isSecurePage = () =>
  typeof window !== "undefined" && window.location.protocol === "https:";

export const buildWsUrl = (host) =>
  isSecurePage()
    ? `wss://${PROXY_HOST}/ws/${host}/`
    : `ws://${host}:${ROSBRIDGE_PORT}`;
